// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-color: var(--cms-intro-bg-color);
  background-image: var(--cms-intro-bg-image);
  background-size: cover;
  background-position: center;
  display: block;
}
:host ion-content {
  --background: var(--cms-intro-bg-color);
}
:host ion-content .centered-card-container {
  height: 100%;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}
:host ion-content .card.login-card .logo {
  height: 9vh;
  max-width: 220px;
}
:host ion-content .card.login-card ion-item ion-button {
  font-size: 1rem;
  --color: var(--ion-color-primary) !important;
  --background: white!important;
}
:host ion-content .card.login-card ion-item.item {
  --border-width: 1px;
  --border-color: var(--ion-color-light);
  --border-radius: 10px;
}
:host ion-content .card.login-card ion-button {
  height: 2.4rem;
  font-size: 1rem;
  margin: 0.4rem 0.2rem;
  --background: var(--cms-button-bg-color);
}
:host ion-content .card.login-card .error-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 8px 5px;
  padding: 10px 12px;
  background-color: rgba(var(--ion-color-danger-rgb), 0.1);
  border: 0px solid var(--ion-color-danger);
  border-radius: 8px;
  animation: fadeInError 0.3s ease-in-out;
}
:host ion-content .card.login-card .error-container .error-icon {
  color: var(--ion-color-danger);
  font-size: 18px;
  flex-shrink: 0;
}
:host ion-content .card.login-card .error-container .error-text {
  color: var(--ion-color-danger);
  font-size: 0.875rem;
  line-height: 1.4;
  flex: 1;
}
@keyframes fadeInError {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:host ion-content .card.login-card small {
  color: var(--ion-color-danger);
}
:host ion-content .card.login-card .terms-container {
  margin-top: 2rem;
}
:host ion-content .card.login-card .terms-container p {
  color: var(--ion-color-medium);
  font-size: 0.8rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login-pages/login-step-one/login-step-one.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACE,2CAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;AACJ;AACE;EAEA,uCAAA;AAAF;AAEI;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAAN;AAKQ;EACE,WAAA;EACA,gBAAA;AAHV;AAQU;EACE,eAAA;EACA,4CAAA;EACA,6BAAA;AANZ;AAUU;EACE,mBAAA;EACA,sCAAA;EACA,qBAAA;AARZ;AAaQ;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,wCAAA;AAXV;AAcQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,wDAAA;EACA,yCAAA;EACA,kBAAA;EACA,uCAAA;AAZV;AAcU;EACE,8BAAA;EACA,eAAA;EACA,cAAA;AAZZ;AAeU;EACE,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;AAbZ;AAiBQ;EACE;IACE,UAAA;IACA,2BAAA;EAfV;EAiBQ;IACE,UAAA;IACA,wBAAA;EAfV;AACF;AAkBQ;EACE,8BAAA;AAhBV;AAmBQ;EACE,gBAAA;AAjBV;AAmBU;EACE,8BAAA;EACA,4BAAA;AAjBZ","sourcesContent":[":host {\n  background-color: var(--cms-intro-bg-color);\n    background-image: var(--cms-intro-bg-image);\n    background-size: cover;\n    background-position: center;\n    display: block;\n\n  ion-content {\n\n  --background: var(--cms-intro-bg-color);\n\n    .centered-card-container {\n      height: 100%;\n      align-items: center;\n      display: flex;\n      flex-wrap: wrap;\n    }\n\n    .card {\n      &.login-card {\n        .logo {\n          height: 9vh;\n          max-width: 220px;\n        }\n\n        ion-item{\n\n          ion-button {\n            font-size: 1rem;\n            --color: var(--ion-color-primary) !important;\n            --background: white!important;\n          }\n \n          \n          &.item{\n            --border-width: 1px;\n            --border-color: var(--ion-color-light);\n            --border-radius: 10px;\n          }\n    \n        }\n\n        ion-button {\n          height: 2.4rem;\n          font-size: 1rem;\n          margin: 0.4rem 0.2rem;\n          --background: var(--cms-button-bg-color);\n        }\n\n        .error-container {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin: 8px 0 8px 5px;\n          padding: 10px 12px;\n          background-color: rgba(var(--ion-color-danger-rgb), 0.1);\n          border: 0px solid var(--ion-color-danger);\n          border-radius: 8px;\n          animation: fadeInError 0.3s ease-in-out;\n          \n          .error-icon {\n            color: var(--ion-color-danger);\n            font-size: 18px;\n            flex-shrink: 0;\n          }\n          \n          .error-text {\n            color: var(--ion-color-danger);\n            font-size: 0.875rem;\n            line-height: 1.4;\n            flex: 1;\n          }\n        }\n\n        @keyframes fadeInError {\n          from {\n            opacity: 0;\n            transform: translateY(-5px);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0);\n          }\n        }\n\n        small {\n          color: var(--ion-color-danger);\n        }\n\n        .terms-container{\n          margin-top: 2rem;\n\n          p{\n            color: var(--ion-color-medium);\n            font-size: 0.8rem !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
